import { render, staticRenderFns } from "./FreightForwardingContractRecord.vue?vue&type=template&id=42250fcc&scoped=true"
import script from "./FreightForwardingContractRecord.vue?vue&type=script&lang=js"
export * from "./FreightForwardingContractRecord.vue?vue&type=script&lang=js"
import style0 from "./FreightForwardingContractRecord.vue?vue&type=style&index=0&id=42250fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42250fcc",
  null
  
)

export default component.exports